var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaveManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#092C4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7073 10.4545C22.8386 9.51651 21.6252 9 20.2859 9C18.9395 9 17.7221 9.51339 16.8574 10.4455C15.9833 11.3879 15.5574 12.6687 15.6574 14.0518C15.8556 16.7803 17.9319 18.9999 20.2859 18.9999C22.6399 18.9999 24.7127 16.7808 24.914 14.0526C25.0154 12.6821 24.5868 11.404 23.7073 10.4545ZM28.143 28.9999H12.4288C12.2231 29.0026 12.0194 28.9594 11.8326 28.8734C11.6457 28.7874 11.4803 28.6609 11.3485 28.503C11.0583 28.1561 10.9413 27.6825 11.0279 27.2035C11.4047 25.1133 12.5806 23.3575 14.4288 22.1249C16.0708 21.0307 18.1507 20.4285 20.2859 20.4285C22.4212 20.4285 24.5011 21.0312 26.143 22.1249C27.9912 23.3571 29.1671 25.1129 29.5439 27.203C29.6305 27.682 29.5135 28.1557 29.2234 28.5026C29.0916 28.6606 28.9262 28.7872 28.7393 28.8732C28.5524 28.9592 28.3487 29.0025 28.143 28.9999Z",
    fill: "#092C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveManagementIcon);
export default __webpack_public_path__ + "static/media/LeaveManagementIcon.9fff4bb2b222ee93b09e7ef02b9b4a51.svg";
export { ForwardRef as ReactComponent };